<template>
    
        <input name="comment-author-input" class="comment-details-input comment-blck-top" :id="'comment-author-input-'+relationId" placeholder="Your name (required)" />
        <input name="comment-author-email-input" class="comment-details-input" :id="'comment-author-email-input-'+relationId" placeholder="Your email (required for the review author)"/>
        <textarea name="comment-input" class="comment-input" :id="'comment-input-'+relationId" placeholder="Share your thoughts. Ask. Your opinion is valuable."></textarea>  
        <button class="comment-input-btn" :id="'comment-input-btn-'+postId" v-on:click="submitComment(postId, addedComments, '')">submit reply</button>

        <!-- Fallback banner immediately below submit button -->
        <div class="inner-banner ad-fallback" style="height: auto; min-height: 50px; margin: 10px 0; display: flex; align-items: center; justify-content: center;">
          <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-desktop">
            <img src="@/assets/banners/banner_970x250.png" alt="Advertisement" class="fallback-banner">
          </a>
          <a href="https://www.reviewstream.com/" target="_blank" rel="nofollow sponsored" class="fallback-banner-link fallback-mobile" style="display: none;">
            <img src="@/assets/banners/banner_360x360.png" alt="Advertisement" class="fallback-banner">
          </a>
        </div>
        
        <div v-if="i>2" class="content-blck-bottom"></div>

</template>


<script>
export default {
  name: "ReplyCommentForm",
  props: ['relation','post_id','addedComments','submitCommentParent', 'count'],
  data() {
    return {
      relationId: this.relation,
      postId: this.post_id,
      addedCommentsArray: this.addedComments,
      i: this.count

    };
  },
methods: {
    submitComment (){
        //let id_ = id
        //let addedComments_ = addedComments
        //let relationId_ = relationId

        //console.log(this.post_id+'...'+this.addedComments+'...'+this.relation)

        this.submitCommentParent(this.post_id,this.addedComments,this.relation);
    }
}    


};
</script>
